import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LetsGoButton, WelcomeRocket, WelcomeSubtitle, WelcomeTitle } from '../Screen1';

import { LevelPicker } from '../Screen2';

import { CourseOffer } from '../Screen2.5';

import DestinationConnector from '../Screen4';
import ReadyToLaunch from '../Screen7';

import { PayPalCardSubtitle, PayPalCard } from '../Screen5';
import { BasicInfo } from '../Screen3';

import { QuickSubscriptionPicker } from '../Screen6';
// import NonApiSelection from '../Screen3.5/NonApiSelection';
import NonApiLearnToUse from '../NonApiScreen7';

export default {
  steps: [
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      content: <WelcomeRocket />,
      bigContent: true,
      currentStage: 0,
      showProgress: false,
      title: <WelcomeTitle />,
      subtitle: <WelcomeSubtitle />,
      primaryButtonContent: <LetsGoButton />,
      secondaryButtonContent: '',
      showBackground: false,
    },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      title: <FormattedMessage id="onboarding.screen2.title" />,
      subtitle: <FormattedMessage id="onboarding.screen2.subtitle" />,
      showProgress: true,
      showBackground: true,
      content: <LevelPicker />,
      bigContent: true,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: '',
      currentStage: 1,
      storeActionBeforeNext: 'updateUserProfile',
    },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      content: <BasicInfo />,
      showProgress: true,
      showBackground: true,
      title: <FormattedMessage id="onboarding.screen3.title" />,
      subtitle: <FormattedMessage id="onboarding.screen3.subtitle" />,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 2,
      // showSkip: true,
      // skipHeight: 131,
      storeActionBeforeNext: 'updateBasicInfo',
    },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      content: <CourseOffer />,
      showProgress: true,
      showBackground: false,
      title: <FormattedMessage id="onboarding.screen2.5.title" />,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      // secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 3,
      forCourse: true,
      // biggerContent: true,
    },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      title: <FormattedMessage id="onboarding.screen4.title" />,
      subtitle: <FormattedMessage id="onboarding.screen4.subtitle" />,
      // subtitle: <WelcomeSubtitle />,
      showBackground: true,
      content: <DestinationConnector />,
      showProgress: true,
      bigContent: true,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 4,
    },
    {
      target: 'body',
      // used to send click handler and css props from the Next button from Tooltip
      content: additionalContentProps => <PayPalCard {...additionalContentProps} />,
      title: (
        <span style={{ lineHeight: '1', display: 'block' }}>
          <FormattedMessage id="onboarding.screen5.title" />
        </span>
      ),
      subtitle: <PayPalCardSubtitle />,
      showProgress: true,
      showBackground: true,
      placement: 'center',
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 5,
      bigContent: true,
    },
    {
      target: 'body',
      content: <QuickSubscriptionPicker />,
      title: <FormattedMessage id="onboarding.screen6.title" />,
      showProgress: true,
      showBackground: true,
      placement: 'center',
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      biggerContent: true,
      currentStage: 6,
      skipHeight: 80,
    },
    {
      target: 'body',
      content: <ReadyToLaunch />,
      title: <FormattedMessage id="onboarding.screen7.title" />,
      subtitle: <FormattedMessage id="onboarding.screen7.subtitle" />,
      showProgress: true,
      showBackground: true,
      placement: 'center',
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.listItem" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      bigContent: true,
      currentStage: 7,
      showSkip: true,
      skipHeight: 96,
      storeActionBeforeNext: 'enableTutorial',
    },
  ],
};

export const NonApiStep7Beginner = {
  target: 'body',
  content: <NonApiLearnToUse />,
  title: <FormattedMessage id="onboarding.screen7NonApi.title" />,
  subtitle: <FormattedMessage id="onboarding.screen7NonApi.subtitle" />,
  showProgress: true,
  showBackground: true,
  placement: 'center',
  primaryButtonContent: <FormattedMessage id="onboarding.buttons.listItem" />,
  secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
  bigContent: true,
  currentStage: 6,
  skipHeight: 96,
  storeActionBeforeNext: 'enableTutorial',
};
